

















































































































import { AxiosError } from 'axios';
import Vue from 'vue';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import {
  IAttachment,
  IVacationCarryOverRequest,
  VacationCarryOverRequestComment,
  VacationCarryOverRequestCommentAttachment
} from '@/models';
import { ErrorManager } from '@/models/error';
import { isHtmlTextEmpty } from '@/utils/helpers';

import CommentAttachmentList from '@/components/common/CommentAttachmentList.vue';
import QuillEditor from '../common/QuillEditor.vue';
import VacationCarryOverRequestCommentListItem from './VacationCarryOverRequestCommentListItem.vue';

export default Vue.extend({
  name: 'VacationCarryOverRequestCommentList',

  components: {
    CommentAttachmentList,
    QuillEditor,
    VacationCarryOverRequestCommentListItem
  },

  props: {
    vacationCarryOverRequest: {
      type: Object as PropType<IVacationCarryOverRequest>,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      isEditing: false,

      commentLoading: false,

      commentErrorMessage: '',
      commentErrorMessageDetail: '',

      comment: new VacationCarryOverRequestComment(),

      mentionsLoading: false,

      attachments: [] as IAttachment[],
      vacationCarryOverRequestCommentValid: false
    };
  },

  computed: {
    ...mapGetters({
      comments: 'vacationCarryOverRequest/getVacationCarryOverRequestComments',
      mentionableUsers:
        'vacationCarryOverRequest/getVacationCarryOverRequestMentionableUsers',
      getLastCreatedVacationCarryOverRequestCommentId:
        'vacationCarryOverRequest/getLastCreatedVacationCarryOverRequestCommentId'
    }),

    canSaveComment(): boolean {
      return !isHtmlTextEmpty(this.comment.text) && !this.commentLoading;
    }
  },

  mounted() {
    this.loading = true;
    this.fetchVacationCarryOverRequestComments(this.vacationCarryOverRequest.id)
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.commentErrorMessageDetail = error.response.data.detail;
          }
        }
        this.commentErrorMessage = ErrorManager.extractApiError(error);

        this.updateErrorMessage();
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchVacationCarryOverRequestComments:
        'vacationCarryOverRequest/fetchVacationCarryOverRequestComments',
      createVacationCarryOverRequestComment:
        'vacationCarryOverRequest/createVacationCarryOverRequestComment',
      fetchVacationCarryOverRequestCommentsMentionableUsers:
        'vacationCarryOverRequest/fetchVacationCarryOverRequestCommentsMentionableUsers',
      addVacationCarryOverRequestCommentAttachments:
        'vacationCarryOverRequest/addVacationCarryOverRequestCommentAttachments'
    }),

    addBaseAttachments(files: File[]) {
      this.attachments.push(
        ...files.map(
          file => new VacationCarryOverRequestCommentAttachment({ file: file })
        )
      );
    },

    updateErrorMessage() {
      this.$emit('setErrorMessage', {
        errorMessage: this.commentErrorMessage,
        errorMessageDetail: this.commentErrorMessageDetail
      });
    },

    clearAllErrors(): void {
      this.commentErrorMessage = '';
      this.commentErrorMessageDetail = '';

      this.updateErrorMessage();
    },

    addVacationCarryOverRequestComment() {
      this.clearAllErrors();

      this.commentLoading = true;

      const parsedCommentMentionText = VacationCarryOverRequestComment.parseHtmlToMentionText(
        this.comment.text
      );

      return this.createVacationCarryOverRequestComment({
        overtimeId: this.vacationCarryOverRequest.id,
        comment: { ...this.comment, text: parsedCommentMentionText }
      })
        .then(async () => {
          this.comment = new VacationCarryOverRequestComment();
          if (this.attachments.length !== 0) {
            await this.addVacationCarryOverRequestCommentAttachments({
              overtimeId: this.vacationCarryOverRequest.id,
              commentId: this.getLastCreatedVacationCarryOverRequestCommentId,
              attachments: this.attachments
            });
            this.attachments = [];
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.commentErrorMessageDetail = error.response.data.detail;
            }
          }
          this.commentErrorMessage = ErrorManager.extractApiError(error);

          this.updateErrorMessage();
        })
        .finally(() => {
          this.commentLoading = false;
        });
    },

    async loadMentionableUsers() {
      this.clearAllErrors();

      this.mentionsLoading = true;
      try {
        await this.fetchVacationCarryOverRequestCommentsMentionableUsers(
          this.vacationCarryOverRequest.id
        );
      } catch (error) {
        this.commentErrorMessage = ErrorManager.extractApiError(
          error as AxiosError
        );
      } finally {
        this.mentionsLoading = false;
      }
    }
  }
});
